import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const CarretinhasPage = lazy(() => import('../pages/carretinhas/page'));
const ComoFuncionaPage = lazy(() => import('../pages/como-funciona/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const CarretinhaParaMotoPage = lazy(() => import('../pages/carretinha-para-moto/page'));
const CarretinhaParaMudancaPage = lazy(() => import('../pages/carretinha-para-mudanca/page'));
const CarretinhaParaObraPage = lazy(() => import('../pages/carretinha-para-obra/page'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/sobre', element: <SobrePage /> },
  { path: '/carretinhas', element: <CarretinhasPage /> },
  { path: '/como-funciona', element: <ComoFuncionaPage /> },
  { path: '/faq', element: <FaqPage /> },
  { path: '/contato', element: <ContatoPage /> },
  { path: '/carretinha-para-moto', element: <CarretinhaParaMotoPage /> },
  { path: '/carretinha-para-mudanca', element: <CarretinhaParaMudancaPage /> },
  { path: '/carretinha-para-obra', element: <CarretinhaParaObraPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
